import React from 'react';
import styled from 'styled-components';

export default function IncomeInfo() {
  return <OuterBox />;
}

const OuterBox = styled.div``;
